import { api, API_URL } from "../config/apiConfig";
import {
  dataPerPage,
  handleUnauthorizedOrForbidden,
} from "../config/varConfig";

// Fetch all gsts
export const getGsts = async (
  page,
  search = "",
  startDate = "",
  endDate = "",
  includeTotal = false,
) => {
  try {
    const response = await api.get(`${API_URL}/transaction/gst`, {
      params: {
        page,
        search,
        limit: dataPerPage,
        startDate,
        endDate,
        includeTotal,
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};
